export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SET_PERMISSIONS = 'SET_PERMISSIONS';
export const ADD_FLASH_MESSAGE = 'ADD_FLASH_MESSAGE';
export const DELETE_FLASH_MESSAGE = 'DELETE_FLASH_MESSAGE';
export const CHANGE_MENU = 'CHANGE_MENU';
export const MANAGE_PERMISSIONS = 'MANAGE_PERMISSIONS';
export const SET_CURRENT_COMPANY = 'SET_CURRENT_COMPANY';
export const SET_CURRENT_USER_PERMISSIONS = 'SET_CURRENT_USER_PERMISSIONS';